const Loader = () => {
    return (
        <div class="loader-container">
            <div class="lds-ripple"><div></div><div></div></div>
        </div>
    );
}
 
export default Loader